import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Filters,
  Image,
  ChoiceList,
  Loading,
  Card,
  Text,
  Spinner,
  Tag,
  Button,
  Modal,
  Badge,
  Toast,
  TextContainer,
  TextField,
  FormLayout,
  Select,
  Icon,
  Layout,
  ButtonGroup,
  Tooltip,
  InlineGrid,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import Pagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import "bootstrap/dist/css/bootstrap.css";

import {
  ExportIcon,
  ProductsMajor,
  SendIcon,
  StarFilledIcon,
  StarIcon,
  CategoriesIcon,
  AlertCircleIcon,
} from "@shopify/polaris-icons";
import SlidingPane from "react-sliding-pane";
import EllipsisText from "react-ellipsis-text";

const Deals = () => {
  const navigate = useNavigate();

  const [isSaving, setIsSaving] = useState(false);
  const refBoolPage = useRef(true);
  const refId = useRef(null);
  const [popupActive, setPopupActive] = useState(false);
  const format = "YYYY-MM-DD HH:mm:ss";
  const perPage = 200;
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [sortState, setSortState] = useState("-id");
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleSort = (index, direction) => {
    console.log("index=", index, direction);
    if (index === 2) {
      direction === "descending"
        ? setSelectedSorting("-first_name")
        : setSelectedSorting("first_name");
    }
    if (index === 10) {
      direction === "descending"
        ? setSelectedSorting("-created_at")
        : setSelectedSorting("created_at");
    }
  };
  // sortState === "id" ? setSortState("-id") : setSortState("id");
  const [ts, setTs] = useState("");
  const clickedDeal = useRef("");

  const handleRowClick = (param) => {
    // navigate(`/admin/crm/deals/${id}`);
    console.log(param);
    param.note ? setNoteValue(param.note) : setNoteValue("");
    clickedDeal.current = param;

    setSliderOpen(true);
    if (typeof window != "undefined" && window.document) {
      document.body.style.overflow = "hidden";
    }
    param.is_favorite
      ? setFavoritesButtonText("Remove from Favorites")
      : setFavoritesButtonText("Add to Favorites");
    setSelectedUserStage(String(param.stage_id));
    setSelectedUserStatus(String(param.status_id));
  };

  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[
    //         { label: "Name", value: "name" },
    //         { label: "Email", value: "email" },
    //         // { label: "Stage", value: "stage" },
    //         // { label: "Campaign", value: "internalCampaign" },
    //         // { label: "Date range", value: "created_between" },
    //       ]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: true,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }

  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This deal have been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeDelete, setActiveDelete] = useState(false);

  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleEdit = (id) => {
    navigate(`/admin/crm/deals/${id}`);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/crm/deals/${refId.current}`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleExport = () => {
    setIsExporting(true);
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/crm/deals/export?stage_id=${
          selectedStage !== "all" && selectedStage !== "" ? selectedStage : ""
        }&from_created_date=${
          startDateValue ? startDateValue : ""
        }&to_created_date=${endDateValue ? endDateValue : ""}&global_search=${
          queryValue ? queryValue : ""
        }`
      )
      .then((result) => {
        setIsExporting(false);
        setToastContent("Please check your email to find the exported sheet");
        toggleActive();
      })
      .catch((err) => console.log(err));
    // window.open(
    //   `${
    //     process.env.REACT_APP_BASE_URL
    //   }/crm/deals/export?token=${"z5qc0gQkrwX5Vjct0enPu6WgOUY8nb67GYIVXx6b"}&stage_id=${
    //     selectedStage !== "all" && selectedStage !== "" ? selectedStage : ""
    //   }&from_created_date=${
    //     startDateValue ? startDateValue : ""
    //   }&to_created_date=${endDateValue ? endDateValue : ""}&global_search=${
    //     queryValue ? queryValue : ""
    //   }`
    // );
  };

  const [startDateValue, setStartDateValue] = useState("");
  const handleChangeStartDate = useCallback(
    (newValue) => setStartDateValue(newValue),
    []
  );
  const [endDateValue, setEndDateValue] = useState("");
  const handleChangeEndDate = useCallback(
    (newValue) => setEndDateValue(newValue),
    []
  );
  const [selectedStage, setSelectedStage] = useState("all");
  const handleSelectChangeStage = useCallback(
    (value) => setSelectedStage(value),
    []
  );
  const [selectedUserStage, setSelectedUserStage] = useState("");

  const [selectedUserStatus, setSelectedUserStatus] = useState("");

  const optionsCategories = [
    { label: "All ", value: "all" },
    { label: "PROSPECT ", value: "1" },
    { label: "CUSTOMER ", value: "2" },
    { label: "SUPPLIER ", value: "3" },
    { label: "PARTNER  ", value: "4" },
  ];
  var randomColor = require("randomcolor");
  const [selectedSorting, setSelectedSorting] = useState("-created_at");
  const handleSelectChangeSorting = useCallback(
    (value) => setSelectedSorting(value),
    []
  );
  const optionsSorting = [
    { label: "Date: New to Old", value: "-created_at" },
    { label: "Date: Old to New", value: "created_at" },
    { label: "Name: A-Z", value: "first_name" },
    { label: "Name: Z-A", value: "-first_name" },
  ];
  const iconStarFilled = () => {
    return (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 800 800"
        style={{ enableBackground: "new 0 0 800 800" }}
        xmlSpace="preserve"
      >
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n\t.st0{fill:#FCCA32;stroke:#FCCA32;stroke-width:60;stroke-miterlimit:10;}\n",
          }}
        />
        <path
          className="st0"
          d="M435,75l81.8,165.7c5.7,11.5,16.7,19.5,29.4,21.4l182.9,26.6c32,4.7,44.8,44,21.6,66.6l-132.3,129
      c-9.2,9-13.4,21.9-11.2,34.6L638.4,701c5.5,31.9-28,56.2-56.7,41.2l-163.6-86c-11.4-6-25-6-36.4,0l-163.6,86
      c-28.7,15.1-62.1-9.3-56.7-41.2l31.2-182.2c2.2-12.7-2-25.6-11.2-34.6l-132.3-129c-23.2-22.6-10.4-62,21.6-66.6l182.9-26.6
      c12.7-1.8,23.7-9.8,29.4-21.4L365,75C379.3,46,420.7,46,435,75z"
        />
      </svg>
    );
  };
  const iconStarOutlined = () => {
    return (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 800 800"
        style={{ enableBackground: "new 0 0 800 800" }}
        xmlSpace="preserve"
      >
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n\t.st0{fill:none;stroke:#FCCA32;stroke-width:60;stroke-miterlimit:10;}\n",
          }}
        />
        <path
          className="st0"
          d="M435,75l81.8,165.7c5.7,11.5,16.7,19.5,29.4,21.4l182.9,26.6c32,4.7,44.8,44,21.6,66.6l-132.3,129
      c-9.2,9-13.4,21.9-11.2,34.6L638.4,701c5.5,31.9-28,56.2-56.7,41.2l-163.6-86c-11.4-6-25-6-36.4,0l-163.6,86
      c-28.7,15.1-62.1-9.3-56.7-41.2l31.2-182.2c2.2-12.7-2-25.6-11.2-34.6l-132.3-129c-23.2-22.6-10.4-62,21.6-66.6l182.9-26.6
      c12.7-1.8,23.7-9.8,29.4-21.4L365,75C379.3,46,420.7,46,435,75z"
        />
      </svg>
    );
  };
  const [categories, setCategories] = useState([
    { label: "All", value: "all" },
  ]);
  const [stages, setStages] = useState([{ label: "All", value: "all" }]);
  const [isExporting, setIsExporting] = useState(false);
  useEffect(() => {
    fetchData();
  }, [
    page,
    sortState,
    availability,
    queryValue,
    ts,
    // startDateValue,
    // endDateValue,
    selectedStage,
    selectedSorting,
  ]);

  async function fetchData() {
    let responseStages = "";
    let responseDeals = "";

    if (stages.length === 1)
      try {
        responseStages = await axios.get(`/crm/deal-stages`);
        responseStages?.data?.data?.data &&
          setStages((currentObjects) =>
            currentObjects.concat([
              ...responseStages.data.data.data.map((item, index) => {
                return {
                  label: item.name,
                  value: String(item.id),
                  key: String(item.id),
                };
              }),
            ])
          );
      } catch (error) {
        console.log(error);
      }

    try {
      responseDeals = await axios.get(
        `/crm/deals?per_page=${perPage}&page=${refBoolPage.current ? page : 1}${
          queryValue ? `&filter[global_search]=${queryValue}` : ""
        }${
          startDateValue && endDateValue
            ? `&filter[created_between]=${startDateValue + "," + endDateValue}`
            : ""
        }${
          selectedStage !== "all" ? `&filter[stage_id]=${selectedStage}` : ""
        }${selectedSorting ? `&sort=${selectedSorting}` : ""}`
      );

      !responseDeals.data.data.data.length
        ? setIsListEmpty(true)
        : setIsListEmpty(false);
      setTotalPages(responseDeals.data.data.total);
      let array = [];

      for (var i = 0; i < responseDeals.data.data.data.length; i++) {
        let colorObjBgd = randomColor({
          // luminosity: "light",
          format: "rgba",
          alpha: 0.4,
        });
        // let colorObjTxt = {
        //   red: rgbToObj(colorObjBgd).red,
        //   blue: rgbToObj(colorObjBgd).blue,
        //   green: rgbToObj(colorObjBgd).green,
        //   alpha: 0.5,
        // };
        let colorObjTxt = `rgba(
            ${rgbToObj(colorObjBgd).red},
            ${rgbToObj(colorObjBgd).green},
            ${rgbToObj(colorObjBgd).blue},
            1
            
          )`;

        array.push({
          id: responseDeals.data.data.data[i].id,
          bgdColor: colorObjBgd,
          textColor: colorObjTxt,
        });
      }
      setItems(
        responseDeals.data.data.data.map((item, index) => [
          <div className="row_click" onClick={() => handleRowClick(item)}>
            <div
              className="circle row_click"
              onClick={() => handleRowClick(item)}
              style={{
                backgroundColor: array.find((x) => x.id === item.id).bgdColor,
              }}
            >
              <b
                style={{
                  color: array.find((x) => x.id === item.id).textColor,
                }}
              >
                {item?.name ? item?.name.toUpperCase().charAt(0) : ""}
              </b>
            </div>
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            <Text as="p" fontWeight="bold">
              {item?.name ? item.name : ""}
            </Text>
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.price !== "" ? item.price : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.purchase_price !== "" ? item.purchase_price : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.cost !== "" ? item.cost : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.stage && item?.stage?.name ? (
              <div
                className="statusDiv"
                style={{ backgroundColor: item.stage.color }}
              >
                {item?.stage?.name}
              </div>
            ) : (
              ""
            )}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.type && item?.type?.description ? (
              <Badge>{item?.type?.description}</Badge>
            ) : (
              ""
            )}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.campaign && item?.campaign?.name ? item?.campaign?.name : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.contact && item?.contact?.first_name
              ? `${item?.contact?.first_name && item.contact.first_name} ${
                  item?.contact?.last_name && item.contact.last_name
                }`
              : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.admin && item?.admin?.first_name
              ? `${item?.admin?.first_name && item.admin.first_name} ${
                  item?.admin?.last_name && item.admin.last_name
                }`
              : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.start_date ? item.start_date : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.expected_close_date ? item.expected_close_date : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.actual_close_date ? item.actual_close_date : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.created_at && moment(item.created_at).format(format)}
          </div>,
          <div style={{ marginRight: "1rem" }}>
            <ButtonGroup>
              <Button onClick={() => handleEdit(item.id)} loading={isSaving}>
                Edit
              </Button>
            </ButtonGroup>
          </div>,
        ])
      );
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  // useEffect(() => {
  //   getData();
  // }, [
  //   page,
  //   sortState,
  //   availability,
  //   queryValue,
  //   ts,
  //   startDateValue,
  //   endDateValue,
  //   selectedStage,
  //   selectedSorting,
  // ]);
  // const getData = () => {
  //   axios
  //     .get(
  //       `/crm/deals?per_page=${perPage}&page=${
  //         refBoolPage.current ? page : 1
  //       }${
  //         queryValue
  //           ? `&filter[${
  //               availability === "" ? "email" : availability
  //             }]=${queryValue}`
  //           : ""
  //       }${
  //         startDateValue && endDateValue
  //           ? `&filter[created_between]=${startDateValue + "," + endDateValue}`
  //           : ""
  //       }${
  //         selectedStage !== "all"
  //           ? `&filter[stage_id]=${selectedStage}`
  //           : ""
  //       }${selectedSorting ? `&sort=${selectedSorting}` : ""}`
  //     )
  //     .then((result) => {
  //       console.log(result.data.data.data);
  //       !result.data.data.data.length
  //         ? setIsListEmpty(true)
  //         : setIsListEmpty(false);
  //       setTotalPages(result.data.data.total);
  //       let array = [];

  //       for (var i = 0; i < result.data.data.data.length; i++) {
  //         let colorObjBgd = randomColor({
  //           // luminosity: "light",
  //           format: "rgba",
  //           alpha: 0.4,
  //         });
  //         // let colorObjTxt = {
  //         //   red: rgbToObj(colorObjBgd).red,
  //         //   blue: rgbToObj(colorObjBgd).blue,
  //         //   green: rgbToObj(colorObjBgd).green,
  //         //   alpha: 0.5,
  //         // };
  //         let colorObjTxt = `rgba(
  //           ${rgbToObj(colorObjBgd).red},
  //           ${rgbToObj(colorObjBgd).green},
  //           ${rgbToObj(colorObjBgd).blue},
  //           1

  //         )`;
  //         console.log("test1=", colorObjBgd);
  //         console.log("test2=", colorObjTxt);
  //         // console.log("tessst1", rgbToObj(colorObj));
  //         // // rgbToObj(colorObj).alpha = 0;
  //         // console.log("tessst2", {
  //         //   red: rgbToObj(colorObj).red,
  //         //   blue: rgbToObj(colorObj).blue,
  //         //   green: rgbToObj(colorObj).green,
  //         //   alpha: 0.5,
  //         // });
  //         // console.log("tessst2", rgbToObj(colorObj).alpha);
  //         array.push({
  //           id: result.data.data.data[i].id,
  //           bgdColor: colorObjBgd,
  //           textColor: colorObjTxt,
  //         });
  //       }
  //       setItems(
  //         result.data.data.data.map((item, index) => [
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             <Icon
  //               source={
  //                 item.is_favorite === 1 ? StarFilledIcon : StarIcon
  //               }
  //               color="warning"
  //             />
  //           </div>,
  //           <div
  //             className="circle row_click"
  //             onClick={() => handleRowClick(item)}
  //             style={{
  //               backgroundColor: array.find((x) => x.id === item.id).bgdColor,
  //             }}
  //           >
  //             <b
  //               style={{
  //                 color: array.find((x) => x.id === item.id).textColor,
  //               }}
  //             >
  //               {item?.first_name && item?.last_name
  //                 ? item?.first_name.charAt(0) + item?.last_name.charAt(0)
  //                 : item?.first_name.charAt(0) + item?.first_name.charAt(1)}
  //             </b>
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             <Text as="p" fontWeight="bold">
  //               {item?.first_name + " " + item?.last_name}
  //             </Text>
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.email && item.email}
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.company?.name && item?.company?.name && item.company.name}
  //           </div>,

  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.tags?.length ? (
  //               <div
  //                 style={{ display: "flex", flexDirection: "row" }}
  //                 key={item.id}
  //               >
  //                 {item.tags.map((item) => {
  //                   return (
  //                     <div style={{ marginLeft: "7px" }} key={item.id}>
  //                       <Tag>{item.name}</Tag>
  //                     </div>
  //                   );
  //                 })}
  //               </div>
  //             ) : (
  //               ""
  //             )}
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.internal_campaign &&
  //               item?.internal_campaign?.name &&
  //               item.internal_campaign.name}
  //           </div>,

  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.stage && item?.stage?.name && item.stage.name}
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.status && item?.status?.name && item.status.name}
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.created_at && moment(item.created_at).format(format)}
  //           </div>,
  //           // <div style={{ marginRight: "1rem" }}>
  //           //   <ButtonGroup>
  //           //     <Button
  //           //       onClick={() => handleDelete(item.id)}
  //           //       destructive
  //           //       loading={isSaving}
  //           //     >
  //           //       Delete
  //           //     </Button>
  //           //   </ButtonGroup>
  //           // </div>,
  //         ])
  //       );
  //       setIsLoading(false);
  //     })
  //     .catch(function (error) {});
  // };
  const [sliderOpen, setSliderOpen] = useState(false);
  const [noteValue, setNoteValue] = useState("");
  const handleChangeNote = useCallback(
    (newValue) => setNoteValue(newValue),
    []
  );
  const [favoritesButtonText, setFavoritesButtonText] = useState("");
  const handleSelectChangeUserStage = (newValue) => {
    setSelectedUserStage(newValue);
    const bodyObj = { stage_id: newValue };
    axios
      .patch(`/crm/deals/${clickedDeal.current.id}/stage`, bodyObj)
      .then((result) => {
        setToastContent("The stage has been changed successfully");
        toggleActive();
        setTs(+new Date());
      })
      .catch((err) => console.logs(err));
  };
  const handleSelectChangeUserStatus = (newValue) => {
    setSelectedUserStatus(newValue);
    const bodyObj = { status_id: newValue };
    axios
      .patch(`/crm/deals/${clickedDeal.current.id}/status`, bodyObj)
      .then((result) => {
        setToastContent("The status has been changed successfully");
        toggleActive();
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const dateSelectHandler = (start, end) => {};
  const cancelDateHandler = (event, picker) => {
    picker.element.val("");
    setStartDateValue("");
    setEndDateValue("");
    setTs(+new Date());
  };
  const applyDataHandler = (event, picker) => {
    picker.element.val(
      picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY")
    );
    setStartDateValue(picker.startDate.format("YYYY/MM/DD"));
    setEndDateValue(picker.endDate.format("YYYY/MM/DD"));
    setTs(+new Date());
  };

  return (
    <Page
      fullWidth
      title="Deals"
      secondaryActions={[
        {
          content: "Export",
          icon: ExportIcon,
          onAction: handleExport,
          loading: isExporting,
        },

        {
          content: "Stages",
          onAction: () => navigate("/admin/crm/deals/stages"),
          // icon: CategoriesIcon,
        },
        {
          content: "Board",
          onAction: () => navigate("/admin/crm/deals/board"),
          // icon: CategoriesIcon,
        },
      ]}
      primaryAction={
        <Button
          variant="primary"
          onClick={() => navigate(`/admin/crm/deals/new`)}
        >
          Add Deal
        </Button>
      }
    >
      <Card>
        {loadingMarkup}

        {/* {availability[0] === "created_between" && ( */}
        <InlineGrid columns={["twoThirds", "oneThird"]} gap="200">
          <Filters
            queryValue={queryValue}
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          />
          <div style={{ marginTop: "0.4rem", marginRight: "0.4rem" }}>
            <Select
              label="Stage:"
              labelInline
              options={stages}
              onChange={handleSelectChangeStage}
              value={selectedStage}
              placeholder="Please select a stage"
            />
          </div>
        </InlineGrid>

        <DateRangePicker
          initialSettings={{
            // autoUpdateInput: false,
            locale: {
              cancelLabel: "Clear",
            },
            startDate: "1/1/2014",
            endDate: "3/1/2014",
          }}
          onCallback={dateSelectHandler}
          onApply={applyDataHandler}
          onCancel={cancelDateHandler}
        >
          <input
            type="text"
            className="form-control col-4"
            // defaultValue={startDateValue + "-" + endDateValue}
            onChange={() => console.log("")}
            value={
              startDateValue && endDateValue
                ? startDateValue + "-" + endDateValue
                : ""
            }
            placeholder="Choose a date"
            // placeholder="Start Date - End Date"
          />
        </DateRangePicker>
        {/* <TextField
                prefix="Start Date:"
                labelInline
                value={startDateValue}
                onChange={handleChangeStartDate}
                type="date"
              />
              <TextField
                prefix="End Date:"
                value={endDateValue}
                onChange={handleChangeEndDate}
                type="date"
              /> */}
        {/* <Select
                label="Sort by:"
                labelInline
                options={optionsSorting}
                onChange={handleSelectChangeSorting}
                value={selectedSorting}
                placeholder="Please select"
              /> */}

        {/* )} */}

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,

            <Text variant="bodyMd" as="p" fontWeight="medium">
              Name
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Price
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Purchase Price
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Cost
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Stage
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Type
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Campaign
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Contact
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Admin
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Start date
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Expected close date
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Actual close date
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Created at
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={items}
          sortable={[
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
          ]}
          defaultSortDirection="descending"
          initialSortColumnIndex={10}
          onSort={handleSort}
          verticalAlign="middle"
          stickyHeader
          // hasZebraStripingOnData
          footerContent={
            items?.length && `Showing ${items.length} of ${totalPages} results`
          }
          increasedTableDensity
        />

        {emtyState}
      </Card>
      {Math.ceil(totalPages / perPage) >= 2 && (
        <div
          style={{
            paddingTop: "10px",
            textAlign: "center",
            paddingBottom: "10px",
          }}
        >
          <Pagination
            count={Math.ceil(totalPages / perPage)}
            page={page}
            onChange={handleChangePage}
            size="large"
          />
        </div>
      )}
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={sliderOpen}
        title={clickedDeal.current?.name}
        // from="bottom"
        // subtitle="Optional subtitle."
        onRequestClose={() => {
          setSliderOpen(false);
          if (typeof window != "undefined" && window.document) {
            document.body.style.overflow = "visible";
          }
        }}
        width="40%"
      >
        <div className="contactDetailsPanel">
          <FormLayout>
            {/* <Text variant="headingSm" as="h6">
              DEAL DETAILS
            </Text> */}
            <FormLayout.Group condensed>
              <div className="columnFlex">
                <b>Name</b>
                <p style={{ height: "0.4rem" }} />
                {clickedDeal.current?.name ? clickedDeal.current?.name : "N/A"}
              </div>
              <div className="columnFlex">
                <b>Created at</b>
                <div style={{ height: "0.4rem" }} />
                {clickedDeal.current?.created_at
                  ? moment(clickedDeal.current?.created_at).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  : "N/A"}
              </div>

              <div className="columnFlex">
                <b>Campaign</b>
                <p style={{ height: "0.4rem" }} />
                {clickedDeal.current?.campaign &&
                clickedDeal.current?.campaign?.name
                  ? clickedDeal.current?.campaign?.name
                  : "N/A"}
              </div>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <div className="columnFlex">
                <b>Price</b>
                <p style={{ height: "0.4rem" }} />
                {clickedDeal.current?.price
                  ? clickedDeal.current?.price
                  : "N/A"}
              </div>
              <div className="columnFlex">
                <b>Purchase Price</b>
                <p style={{ height: "0.4rem" }} />
                {clickedDeal.current?.purchase_price
                  ? clickedDeal.current?.purchase_price
                  : "N/A"}
              </div>
              <div className="columnFlex">
                <b>Cost</b>
                <div style={{ height: "0.4rem" }} />
                {clickedDeal.current?.cost ? clickedDeal.current?.cost : "N/A"}
              </div>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <div className="columnFlex">
                <b>Contact</b>
                <p style={{ height: "0.4rem" }} />
                {clickedDeal?.current?.contact &&
                clickedDeal?.current?.contact?.first_name
                  ? `${
                      clickedDeal?.current?.contact?.first_name &&
                      clickedDeal?.current.contact.first_name
                    } ${
                      clickedDeal?.current?.contact?.last_name &&
                      clickedDeal?.current.contact.last_name
                    }`
                  : "N/A"}
              </div>
              <div className="columnFlex">
                <b>Admin</b>
                <p style={{ height: "0.4rem" }} />
                {clickedDeal?.current?.admin &&
                clickedDeal?.current?.admin?.first_name
                  ? `${
                      clickedDeal?.current?.admin?.first_name &&
                      clickedDeal?.current.admin.first_name
                    } ${
                      clickedDeal?.current?.admin?.last_name &&
                      clickedDeal?.current.admin.last_name
                    }`
                  : "N/A"}
              </div>
              <div className="columnFlex">
                <b>Stage</b>
                <div style={{ height: "0.4rem" }} />
                {clickedDeal.current?.stage && clickedDeal.current?.stage?.name
                  ? clickedDeal.current?.stage?.name
                  : "N/A"}
              </div>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <div className="columnFlex">
                <b>Start Date</b>
                <p style={{ height: "0.4rem" }} />
                {clickedDeal?.current?.start_date
                  ? clickedDeal?.current?.start_date
                  : "N/A"}
              </div>
              <div className="columnFlex">
                <b>Expected Close Date</b>
                <div style={{ height: "0.4rem" }} />
                {clickedDeal?.current?.expected_close_date
                  ? clickedDeal?.current?.expected_close_date
                  : "N/A"}
              </div>
              <div className="columnFlex">
                <b>Actual Close Date</b>
                <div style={{ height: "0.4rem" }} />
                {clickedDeal?.current?.actual_close_date
                  ? clickedDeal?.current?.actual_close_date
                  : "N/A"}
              </div>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <div className="columnFlex">
                <b>Type</b>
                <p style={{ height: "0.4rem" }} />
                {clickedDeal?.current?.type &&
                clickedDeal?.current?.type?.description
                  ? clickedDeal?.current?.type?.description
                  : "N/A"}
              </div>
            </FormLayout.Group>
          </FormLayout>
        </div>
        <div className="footer mb-3">
          <FormLayout.Group>
            {/* <Button
              primary
              fullWidth
              loading={isSaving}
              onClick={() => {
                setIsSaving(true);
                axios
                  .patch(
                    `/crm/deals/${clickedDeal.current.id}/favorites/toggle`
                  )
                  .then((result) => {
                    console.log("tesstt=", result.data.data);
                    result.data.data.is_favorite
                      ? setFavoritesButtonText("Remove from Favorites")
                      : setFavoritesButtonText("Add to Favorites");
                    setIsSaving(false);
                    setTs(+new Date());
                  })
                  .catch((err) => console.log(err));
              }}
              // icon={
              //   clickedDeal.current.is_favorite
              //     ? iconStarFilled
              //     : iconStarOutlined
              // }
            >
              {favoritesButtonText}
            </Button> */}
            <Button
              destructive
              loading={isSaving}
              fullWidth
              // icon={DeleteMajor}
              onClick={() => {
                setSliderOpen(false);
                handleDelete(clickedDeal.current.id);
              }}
            >
              Delete
            </Button>
          </FormLayout.Group>
        </div>
      </SlidingPane>
      <Modal open={popupActive} loading={true}></Modal>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Deal"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this deal?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Page>
  );

  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      // case "productType":
      //   return value.join(", ");
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
  function rgbToObj(rgb) {
    let colors = ["red", "green", "blue", "alpha"];

    let colorArr = rgb
      .slice(rgb.indexOf("(") + 1, rgb.indexOf(")"))
      .split(", ");

    let obj = new Object();

    colorArr.forEach((k, i) => {
      obj[colors[i]] = k;
    });

    return obj;
  }
};

export default Deals;
